import styled, { css } from 'styled-components';
export var ToggleContainer = styled.div.withConfig({
  displayName: "styled__ToggleContainer",
  componentId: "sc-1b7mc65-0"
})(["margin-left:8px;"]);
export var ToggleIcon = styled.div.withConfig({
  displayName: "styled__ToggleIcon",
  componentId: "sc-1b7mc65-1"
})(["position:relative;width:28px;height:16px;border-radius:14px;transition:background-color 0.2s ease;will-change:background-color;&::before{content:'';position:absolute;left:2px;top:2px;width:12px;height:12px;background:#fff;border-radius:6px;z-index:1;transition:transform 0.2s ease;will-change:transform;}"]);

var themedToggle = function themedToggle(bg, checkedBg, hoverBg, disabledBg) {
  return css(["& + ", "{background-color:", ";}&:checked + ", "{background-color:", ";}&:disabled + ", "{background-color:", ";}"], ToggleIcon, bg, ToggleIcon, checkedBg, ToggleIcon, disabledBg);
};

export var ToggleInput = styled.input.withConfig({
  displayName: "styled__ToggleInput",
  componentId: "sc-1b7mc65-2"
})(["appearance:none;position:absolute;&:checked + ", "::before{transform:translateX(12px);transition:transform 0.2s ease;}&:disabled + ", "{cursor:default;}", ""], ToggleIcon, ToggleIcon, function (_ref) {
  var theme = _ref.theme;
  var _theme$toggle = theme.toggle,
      bg = _theme$toggle.bg,
      checkedBg = _theme$toggle.checkedBg,
      hoverBg = _theme$toggle.hoverBg,
      disabledBg = _theme$toggle.disabledBg;
  return themedToggle(bg, checkedBg, hoverBg, disabledBg);
});
export var ToggleWrapper = styled.label.withConfig({
  displayName: "styled__ToggleWrapper",
  componentId: "sc-1b7mc65-3"
})(["display:inline-block;", ""], function (_ref2) {
  var theme = _ref2.theme;
  return css(["padding:", "px;margin:", "px;&:not(.disabled){cursor:pointer;&:hover ", ",&:focus ", "{background-color:", ";}}"], theme.baseIndent * theme.toggle.tapArea, -theme.baseIndent * theme.toggle.tapArea, ToggleIcon, ToggleIcon, theme.toggle.hoverBg);
});